import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import findDocument from "cc-frontend/helpers/find-document"
import _ from "lodash"

export default class AdminUserActions extends Component {
  @service("ember-store")
  store

  @service
  rpc

  @service
  query

  results = []
  userQuery = null
  selectedActionId = null
  nextOffset = 0

  @findDocument("selectedActionId", "action") selectedAction

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments)
    if (get(this, "model.id") && get(this, "userQuery") === null) {
      let queryId = get(this, "model.id")
      let userQuery = get(this, "query").generateLiveQuery("actions_for_user", queryId, () => {
        this.fetchQuery()
      })
      set(this, "userQuery", userQuery)
      scheduleOnce("afterRender", () => this.fetchQuery())
    }
  }

  fetchQuery() {
    if (get(this, "nextOffset") === null) return
    set(this, "isFetchingQuery", true)
    get(this, "query")
      .fetch(get(this, "userQuery"), get(this, "nextOffset"), 200)
      .then((response) => {
        let data = response.data
        if (this.isDestroyed || this.isDestroying) return
        let meta = response.meta || {}

        set(this, "nextOffset", meta.nextOffset)

        let groupedData = _.chain(data.results)
          .groupBy((datum) => {
            return datum.meta.dateString ? datum.meta.dateString.slice(0, 10) : "Undated"
          })
          .map((dates, date) => {
            return [{ dateString: date }, dates]
          })
          .flattenDeep()
          .value()

        if (get(this, "selectedActionId") === null && data.results[0] !== undefined) {
          set(this, "selectedActionId", data.results[0].id)
        }
        set(this, "results", get(this, "results").concat(groupedData))
        set(this, "isFetchingQuery", false)
      })
  }

  @action
  selectAction(id) {
    set(this, "selectedActionId", id)
  }

  @action
  loadMoreBelow() {
    this.fetchQuery()
  }

  @action
  stopImpersonating() {
    get(this, "session").stopImpersonating()
    window.location.reload()
  }
}
